var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2094_4007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 15.75C6.75 16.1625 7.0875 16.5 7.5 16.5H10.5C10.9125 16.5 11.25 16.1625 11.25 15.75V15H6.75V15.75ZM9 1.5C6.105 1.5 3.75 3.855 3.75 6.75C3.75 8.535 4.6425 10.1025 6 11.055V12.75C6 13.1625 6.3375 13.5 6.75 13.5H11.25C11.6625 13.5 12 13.1625 12 12.75V11.055C13.3575 10.1025 14.25 8.535 14.25 6.75C14.25 3.855 11.895 1.5 9 1.5ZM11.1375 9.825L10.5 10.275V12H7.5V10.275L6.8625 9.825C5.85 9.12 5.25 7.9725 5.25 6.75C5.25 4.68 6.93 3 9 3C11.07 3 12.75 4.68 12.75 6.75C12.75 7.9725 12.15 9.12 11.1375 9.825Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2094_4007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAn);
export default __webpack_public_path__ + "static/media/AN.9eca80fbe495009fd360a94e7645affd.svg";
export { ForwardRef as ReactComponent };